import React, { useState, useEffect } from "react";
import "../../styles/Buttons.css";
import "../../styles/Containers.css";
import "../../styles/Fonts.css";
import "../../styles/Colors.css";
import TopNavbarBack from "../../components/TopNavbarBack";
import TopNavbar from "../../components/TopNavbar";
import "react-toastify/dist/ReactToastify.css";
import GoToTop from "../../components/GoToTop";
import LoadingPage from "../../components/LoadingPage";
import {
  NoSubscription,
  PlanFace,
  ActiveSubscription,
} from "./components/NoSubscription";
import { useFetch } from "../../custom/api";

export default function Menu() {
  const [plans, setPlans] = useState([]);
  const [activePlan, setActivePlan] = useState(null);
  const { myFetch } = useFetch();

  useEffect(() => {
    const fetchData = async () => {
      const resp = await myFetch(`plans`, { method: "Get" });
      const r = await resp.json();
      setPlans(r.plans);
      setActivePlan(r.active_plan);
    };
    fetchData();
  }, []);

  return (
    <div className="">
      
      <TopNavbar
        title=""
        rbuttonIcon={["icon-iconchevron-right"]}
        rbuttonHref={["/"]}
        rbackground={["rectangle"]}
        lbuttonIcon={[""]}
        lbuttonHref={["null"]}
        lbackground={["bTransparent"]}
      />

      <div className="main-container">
      {activePlan === null ? (
        <LoadingPage />
      ) : Object.keys(activePlan).length === 0 ? (
        <NoSubscription />
      ) : (
        <ActiveSubscription active_plan={activePlan} />
      )}


        {plans.map((plan) => {
          return (
            <PlanFace
              key={plan.plan_id}
              planInfo={plan}
              activePlan={activePlan}
              setActivePlan={setActivePlan}
            ></PlanFace>
          );
        })}
      </div>

      <GoToTop />
    </div>
  );
}
